import cityGetters from './city/getters'
import placeGetters from './place/getters'
import contactGetters from './contact/getters'

export default {
  ...cityGetters,
  ...placeGetters,
  ...contactGetters
}
